import { Directive} from '@angular/core';
import { TemplateRefDirective } from 'src/app/utils/template-ref-directive';

@Directive({
    selector: '[appListingAfterSearchbarButtons]',
    standalone: false
})
export class ListingAfterSearchbarButtonsDirective extends TemplateRefDirective {
}
